// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  CLEAR_SCHEDULE_DATA,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS,
  FETCH_CONTRACTOR_LOGS_FAILURE,
  FETCH_CONTRACTOR_LOGS_REQUEST,
  FETCH_CONTRACTOR_LOGS_SUCCESS,
  UPDATE_SCHEDULE_DATA,
} from "../constants/contractorScheduleTabConstants";
import {
  FETCH_SINGLE_POSITION_DATA_FAILURE,
  FETCH_SINGLE_POSITION_DATA_REQUEST,
  FETCH_SINGLE_POSITION_DATA_SUCCESS,
} from "../constants/schedule";
import { alertDialogAciton } from "./auth";

export const fetchPositionsOfAssignedContractorAction = ({
  params,
  beforeRequestCallback,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST,
      payload: {
        startDate: params?.startDate || "",
        endDate: params?.endDate || "",
      },
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getPositionsOfAssignedContractor`,
      // url: `getNewEventsForSuperAdmins?page=${payload?.page}`,
      params,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      // dispatch({
      //     type: FETCH_NEW_EVENT_SUCCESS,
      //     payload: response?.data?.data,
      // });
      dispatch({
        type: FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS,
        payload: {
          schedules: response?.data?.eventData,
          currentPage: response?.data?.currentPage,
          totalPages: response?.data?.totalPages,
          totalItems: response?.data?.eventCount,
        },
      });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE });
    }
  };
};

export const fetchSinglePositionDataAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SINGLE_POSITION_DATA_REQUEST });
    const { error, response } = await apiRequest({
      method: "GET",
      url: `getSinglePositionData`,
      params: payload,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: FETCH_SINGLE_POSITION_DATA_SUCCESS,
        payload: response.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({
        type: FETCH_SINGLE_POSITION_DATA_FAILURE,
      });
      if (failureCallback) failureCallback();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to fetch position data",
        }),
      );
    }
  };
};

// clear schedule data
export const clearScheduleDataAction = () => {
  return {
    type: CLEAR_SCHEDULE_DATA,
  };
};

// update schedule data
export const updateScheduleDataAction = (payload) => {
  return {
    type: UPDATE_SCHEDULE_DATA,
    payload,
  };
};

// fetch only logs
export const fetchContractorLogsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CONTRACTOR_LOGS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getLogsOfEventOfContractor?eventId=${payload?.eventId}`,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_CONTRACTOR_LOGS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_CONTRACTOR_LOGS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};